

export default {
  props: {
    tenderId: {
      type: String,
      required: true
    },

    lotNumber: {
      type: [String, Number],
      required: true
    },

    preview: {
      type: Boolean
    }
  },
  data () {
    return {
      expanded: true,

      dates: []
    };
  },

  async fetch () {
    if (this.preview) { return; }
    this.dates = await this.$axios.$get(`/tenderplanningitem/${this.tenderId}`);
  },

  computed: {
    sortedDates () {
      const key = Object.keys(this.dates).find(x => x.toLowerCase() === this.lotNumber.toLowerCase());
      if (!key) {
        return [];
      }

      return [...this.dates[key]].sort(
        (a, b) => new Date(b.date) - new Date(a.date)
      );
    }
  }
};
